import { render, staticRenderFns } from "./StrapiList.vue?vue&type=template&id=5755dae7&scoped=true&"
import script from "./StrapiList.vue?vue&type=script&lang=js&"
export * from "./StrapiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5755dae7",
  null
  
)

export default component.exports